module.exports = __webpack_public_path__ + "static/img/shuzhiSlogin.df42e1a4.png";